export default __webpack_public_path__ + "static/media/dumptabs.9b7271d1.gif";